import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
`;

export const Field = styled.div`
  flex: 1;
  position: relative;

  &.copy {
    .value {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 300px;
      padding-right: 40px;
    }

    .copy {
      display: block;
    }
  }
`;

export const Label = styled.div`
  font-size: 12px;
  padding: 0px 10px;
  color: #778;
  border-top: 1px solid #334;
`;

export const Value = styled.div`
  font-size: 18px;
  padding: 0 10px 2px 7px;
  min-height: 30px;
`;

export const Copy = styled.div`
  cursor: pointer;
  display: none;
  position: absolute;
  top: 2px;
  right: 0;
  padding: 0 10px;
`;
